import Heading from "components/Heading/Heading";
import { Button, Form, message } from "antd";
import { useState } from "react";
import FormModal from "./FormModal";
import dayjs from "dayjs";
import { useGetCostCentersQuery } from "../../../redux/Service/costCenter";
import { useGetSellersQuery } from "../../../redux/Service/sellersApi";
import { useGetCurrenciesQuery } from "../../../redux/Service/currenciesApi";
import { useGetBoxsQuery } from "../../../redux/Service/BoxesApi";
import { useGetBanksQuery } from "../../../redux/Service/BanksApi";
import { useGetBranchesQuery } from "../../../redux/Service/branches";
import { useGetVendorsQuery } from "../../../redux/Service/vendorsApi";
import { useGetCustomersQuery } from "../../../redux/Service/customersApi";
import { useAddCashInMutation } from "../../../redux/Service/cashInApi";

function CashIn() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [subData, setSubData] = useState<any>([]);

  const [addCashOut, { isLoading: isAdding }] = useAddCashInMutation();

  const { data: sellersData } = useGetSellersQuery(undefined);
  const { data: costCentersData } = useGetCostCentersQuery(undefined);
  const { data: currenciesData } = useGetCurrenciesQuery(undefined);

  const sellers = sellersData?.ResponseObject ?? [];
  const costCenters = costCentersData?.ResponseObject ?? [];
  const currencies = currenciesData?.ResponseObject ?? [];

  const { data: boxesData } = useGetBoxsQuery(undefined);
  const boxes = boxesData?.ResponseObject ?? [];

  const { data: banksData } = useGetBanksQuery(undefined);
  const banks = banksData?.ResponseObject ?? [];

  const { data: branchesData } = useGetBranchesQuery(undefined);
  const branches = branchesData?.ResponseObject ?? [];

  const { data: vendorsData } = useGetVendorsQuery(undefined);
  const vendors = vendorsData?.ResponseObject ?? [];

  const { data: customersData } = useGetCustomersQuery(undefined);
  const customers = customersData?.ResponseObject ?? [];

  const handleOk = async (values: any) => {
    const body = {
      ...values,
      DocDate: values.DocDate?.format("YYYY-MM-DD"),
      FinCashDets: subData,
    };

    try {
      const response = await addCashOut(body).unwrap();
      if (response?.ResponseObject == true) {
        message.success("تمت إضافة عملية القبض بنجاح");
        handleCancel();
      } else {
        message.error("حدث خطأ أثناء الإضافة");
      }
    } catch (error) {
      message.error("فشل الاتصال بالخادم");
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    setSubData([]);
  };

  return (
    <>
      <Heading name="قبض نقدي" />

      <div className="grid justify-start">
        <Button type="primary" onClick={() => setIsModalOpen(true)}>
          قبض جديد
        </Button>
      </div>

      <FormModal
        form={form}
        isEditing={false}
        isModalOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        initialValues={{ DocDate: dayjs() }}
        loading={isAdding}
        subData={subData}
        setSubData={setSubData}
        sellers={sellers}
        costCenters={costCenters}
        currencies={currencies}
        boxes={boxes}
        banks={banks}
        branches={branches}
        customers={customers}
        vendors={vendors}
      />
    </>
  );
}

export default CashIn;
